import { number, oneOfType, string } from 'prop-types'
import React from 'react'

const StatsItem = (props) => {
  if (!props.value) {
    return null
  }
  return (
    <div className={`stats-item ${props.slug}`}>
      <div className="heading">{props.heading}</div>
      <div className="value">
        {props.value}
      </div>
    </div>
  )
}
StatsItem.defaultProps = {
  value: null,
}
StatsItem.propTypes = {
  heading: string.isRequired,
  slug: string.isRequired,
  value: oneOfType([number, string]),
}

export default StatsItem
